import { render, staticRenderFns } from "./ResultReferencePanel.vue?vue&type=template&id=b45d835a&scoped=true&"
import script from "./ResultReferencePanel.vue?vue&type=script&lang=js&"
export * from "./ResultReferencePanel.vue?vue&type=script&lang=js&"
import style0 from "./ResultReferencePanel.vue?vue&type=style&index=0&id=b45d835a&lang=scss&scoped=true&"
import style1 from "./ResultReferencePanel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45d835a",
  null
  
)

export default component.exports